export const CO2_PRICE_PER_KG_PENCE = 5.39; // MUST BE 2dp to match precision in xero
